import React, { forwardRef, useEffect, useRef, useState, useMemo } from 'react';
import './AdventureSection.css';
import { motion } from 'framer-motion';
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { IMAGE_DIR_PATH, PUBLIC_CMS_URL } from '../../../APIs/endpoint';
import { getUrlAfterDomain, formatThemePathSegmentsString } from '../../../helper/global';
import WhyIndiaSkeleton from '../../Loader/WhyIndiaSkeleton';
import CustomButton from '../../Common/button';

const MotionBox = motion.create(Box);

const AdventureSection = forwardRef(({ whyIndiaData, themeData }, ref) => {
  const navigate = useNavigate();
  const firstBoxRef = useRef(null);
  const [loading, setLoading] = useState(true);

  const sortedWhyIndiaData = useMemo(
    () => whyIndiaData?.sort((a, b) => b.whyindia_sequence_no - a.whyindia_sequence_no),
    [whyIndiaData]
  );

  useEffect(() => {
    if (whyIndiaData && whyIndiaData.length > 0) {
      setLoading(false);
    }
    if (firstBoxRef.current) {
      window.scrollTo(0, 0);
    }
  }, [whyIndiaData]);

  const headingVariants = {
    hidden: { opacity: 0, x: -100 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.8, delay: 0.6 } }
  };

  const subheadingVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 1, delay: 0.8 } }
  };

  const descriptionVariants = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: { opacity: 1, scale: 1, transition: { duration: 1, delay: 1 } }
  };

  const handlePackageThemed = (themedUrl) => {
    const lastSegment = formatThemePathSegmentsString(themedUrl.split('/').pop());
    navigate(getUrlAfterDomain(themedUrl), {
      state: {
        themeFilterData: themeData.map((obj) => ({
          label: obj.theme,
          value: obj.theme,
          isSelected: obj.theme === lastSegment
        }))
      }
    });
  };

  return (
    <>
      {loading ? (
        <>
          <WhyIndiaSkeleton />
          <WhyIndiaSkeleton />
          <WhyIndiaSkeleton />
        </>
      ) : (
        sortedWhyIndiaData?.length > 0 &&
        sortedWhyIndiaData.map((item, index) => (
          <Box
            className="hero-section"
            key={index}
            ref={
              index === 0
                ? (el) => {
                    firstBoxRef.current = el;
                    ref.current = el;
                  }
                : null
            }>
            <Box className="hero-text">
              <MotionBox initial="hidden" animate="visible" variants={headingVariants}>
                <Typography className="hero-heading">{item?.whyindia_no}</Typography>
              </MotionBox>
              <Box>
                <MotionBox initial="hidden" animate="visible" variants={subheadingVariants}>
                  <Typography className="hero-subheading">{item.whyindia_title}</Typography>
                </MotionBox>

                <MotionBox initial="hidden" animate="visible" variants={descriptionVariants}>
                  <Typography className="hero-description">{item.whyindia_description}</Typography>
                </MotionBox>
                <Box className="adventure-section-btn-container">
                  <CustomButton
                    title="Explore with Us"
                    onClick={() => handlePackageThemed(item.whyindia_url)}
                  />
                </Box>
              </Box>
            </Box>
            {/* <Box
              component="img"
              loading="lazy"
              srcSet={`
                ${PUBLIC_CMS_URL}${IMAGE_DIR_PATH.WHY_INDIA_PATH}${item.whyindia_image}?w=600 600w,
                ${PUBLIC_CMS_URL}${IMAGE_DIR_PATH.WHY_INDIA_PATH}${item.whyindia_image}?w=1024 1024w,
                ${PUBLIC_CMS_URL}${IMAGE_DIR_PATH.WHY_INDIA_PATH}${item.whyindia_image}?w=1440 1440w
              `}
              sizes="(max-width: 600px) 600px, (max-width: 1024px) 1024px, 1440px, 1920px"
              src={`${PUBLIC_CMS_URL}${IMAGE_DIR_PATH.WHY_INDIA_PATH}${item.whyindia_image}`}
              alt="Adventure in India"
              className="hero-image"
            /> */}
            <Box
              component="img"
              loading="lazy"
              srcSet={`
    ${PUBLIC_CMS_URL}${IMAGE_DIR_PATH.WHY_INDIA_PATH}${item.whyindia_image}?w=600 600w,
    ${PUBLIC_CMS_URL}${IMAGE_DIR_PATH.WHY_INDIA_PATH}${item.whyindia_image}?w=1024 1024w,
    ${PUBLIC_CMS_URL}${IMAGE_DIR_PATH.WHY_INDIA_PATH}${item.whyindia_image}?w=1440 1440w,
    ${PUBLIC_CMS_URL}${IMAGE_DIR_PATH.WHY_INDIA_PATH}${item.whyindia_image}?w=1920 1920w
  `}
              sizes="
    (max-width: 600px) 600px, 
    (max-width: 1024px) 1024px, 
    (max-width: 1440px) 1440px, 
    1920px
  "
              src={`${PUBLIC_CMS_URL}${IMAGE_DIR_PATH.WHY_INDIA_PATH}${item.whyindia_image}`}
              alt={item.alt_text || 'Adventure in India'}
              className="hero-image"
            />
          </Box>
        ))
      )}
    </>
  );
});

AdventureSection.displayName = 'AdventureSection';

export default AdventureSection;
